import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    BlockType,
    ComponentSettings,
    NewBlockContextType,
    ComponentSettingsDatasetField,
    ComponentSettingsDatasetSortField,
} from '@report-content';

export class BlockFactoryJct extends AbstractBlockFactory<ComponentSettingsJct> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
        jctId,
        name,
        properties,
    }: NewBlockContextType & { jctId: number; name: string; properties: any }): BlockType<ComponentSettingsJct> {
        const uid = 'block_uid_' + nextUId;

        const fields: Array<ComponentSettingsJctField> = datasetFields.map((f, i) => {
            return {
                columnSize: 200,
                aggregation_method: '',
                column_name: f.column_name,
                column_sequence: f.column_sequence,
                dataset_column_id: Number(f.dataset_column_id),
                dataset_filter_column_id: Number(f.dataset_filter_column_id),
                dataset_filter_id: Number(f.dataset_filter_id),
                dataset_id: Number(f.dataset_id),
                display_mask_id: f.display_mask_id,
                field: f.column_name,
                id: f.reference_name,
                reference_name: f.reference_name,
                reference_name_escaped: f.reference_name_escaped,
                show_column_in_table_display_ind: 'Y',
                value_type: f.value_type,
                override_header_ind: 'N',
                label: f.label,
                break_column: 'N',
                group_column: 'N',
                compute_result_total_ind: 'Y',
                fieldProperties: { axis_number: '1', column_chart_value_display_type: 'line' },
                fieldSettings: [],
            };
        });

        return {
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                //@ts-ignore
                internalName: `jct_${jctId}`,
                settings: {
                    groupFilter: { operator: 'AND', rules: [] },
                    fields: fields,
                    properties: properties,
                    component_name: name,
                    uid: uid,
                    //@ts-ignore
                    internal_name: `jct_${jctId}`,
                    title: '',
                    height: 600,
                    show_in_viewer: 'Y',
                    is_preview_ind: 'N',
                    include_in_email: 'Y',
                    // is_preview_ind: 'Y',
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    report_no_units_label: 'No exceptions',
                    report_single_unit_label: 'exception',
                    report_multiple_units_label: 'exceptions',
                    isOnCreation: true,
                    sortFields: [],
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsJct extends ComponentSettings {
    uid: string;
    component_name: string;
    fields: Array<ComponentSettingsJctField>;
    properties: {
        templateProperties: Array<{ name: string; value: string }>;
    };
    report_no_units_label: 'No exceptions';
    report_single_unit_label: 'exception';
    report_multiple_units_label: 'exceptions';
    sortFields: Array<ComponentSettingsDatasetSortField>;
}

export interface ComponentSettingsJctField extends ComponentSettingsDatasetField {
    fieldProperties: { axis_number: '1'; column_chart_value_display_type: 'line' };
    fieldSettings: Array<{ name: string; value: string }>;
}
